export default "__VITE_ASSET__CkMIasPA__"